module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Drive_16"],"path":[{"$":{"d":"M12,0V15H11v1H5V15H4V0ZM11,9H8l2-4L5,10H8L6,14ZM10,2H6V4h4Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Drive_16.svg
// module id = z47c
// module chunks = 1